import { render, staticRenderFns } from "./reJobItemPerson.vue?vue&type=template&id=229d1e56&scoped=true"
import script from "./reJobItemPerson.vue?vue&type=script&lang=js"
export * from "./reJobItemPerson.vue?vue&type=script&lang=js"
import style0 from "./reJobItemPerson.vue?vue&type=style&index=0&id=229d1e56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d1e56",
  null
  
)

export default component.exports